import React, { useState, useEffect } from "react";
import { Form, Col, Select, message } from "antd";
import api from "Common/Client/Interceptor";
import { useLocation, useNavigate } from "react-router-dom";

const { Option } = Select;

const usePerformanceReviewForm = () => {
  const managerId = localStorage.getItem("personalId");
  const token = localStorage.getItem("token");
  const location = useLocation();
  const navigate = useNavigate();
  const { learnerId, firstName, lastName } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [recommendCourses, setRecommendCourses] = useState([]);
  const [form] = Form.useForm();

  // Rating options (1 to 5)
  const ratingOptions = [1, 2, 3, 4, 5].map((value) => (
    <Option key={value} value={value}>
      {value}
    </Option>
  ));

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await api.get('/Library/Courses/Lookup', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setRecommendCourses(response.data || []);
      } catch (error) {
        console.error("Failed to fetch courses", error);
      }
    };
    fetchCourses();
  }, [token]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        ...values,
        managerId: Number(managerId),
        learnerId: learnerId,
        courseId: values.courseId || 0,
      };

      await api.post("/PerformanceReview/create", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      });

      message.success("Performance review submitted successfully!");
      navigate("/employees");
      form.resetFields();
    } catch (error) {
      console.error("Error", error);
    } finally {
      setLoading(false);
    }
  };

  const renderFormItem = (name, label, component) => (
    <Col xs={24} sm={24} md={12} lg={12} key={name}>
      <Form.Item name={name} label={label} rules={[{ required: true }]}>
        {component}
      </Form.Item>
    </Col>
  );

  return {
    recommendCourses,
    form,
    navigate,
    firstName,
    lastName,
    loading,
    ratingOptions,
    onFinish,
    renderFormItem,
    learnerId,
  };
};

export default usePerformanceReviewForm;